<template>
  <li
    data-test-id="list-item"
    :class="[
      $style['list-item'],
      { [$style[`list-item--${color}`]]: color },
      { [$style['list-item--clickable']]: to || attrs.onClick },
      { [$style['list-item--header']]: header }
    ]">
    <component
      :is="to ? nuxtLink : 'div'"
      :class="$style['list-item__inner']"
      direction="forward"
      :active-class="$style['list-item--active']"
      :exact-active-class="$style['list-item--active']"
      :to="to">
      <SvgIcon
        v-if="icon && !disableIcon"
        :class="[$style['list-item__icon'], $style[`list-item__icon--${iconColor}`]]"
        :name="icon" />

      <slot />

      <SvgIcon
        v-if="(to || attrs.onClick) && !disableArrow"
        :class="[
          $style['list-item__action-icon'],
        ]"
        name="System/arrow-right-s-line" />
    </component>
  </li>
</template>
<script setup>
const attrs = useAttrs()
const nuxtLink = resolveComponent('nuxt-link')
const props = defineProps({
  icon: {
    type: String,
    default: null
  },
  to: {
    type: [String, Object],
    default: null
  },
  header: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: '',
    validator: value => ['', 'red']
  },
  iconColor: {
    type: String,
    default: '',
    validator: value => ['', 'black', 'green'].includes(value)
  },
  disableIcon: {
    type: Boolean,
    default: false
  },
  disableArrow: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" module>
.list-item {
  display: inline-flex;
  align-items: center;
  font-size: var(--font-size-s);
  list-style-type: none;

  a {
    color: inherit;
    text-decoration: none;
  }

  &__icon {
    fill: currentcolor;
    margin-right: calc(var(--spacing ) * 2);

    &--black {
      color: var(--black)
    }

    &--green {
      color: var(--success);
    }
  }

  &__action-icon {
    margin-left: auto;
    flex-shrink: 0;
  }

  &__inner {
    display: flex;
    align-items: center;
    padding: calc(var(--spacing) * 2);
    padding-left: var(--spacing);
    width: 100%;
  }

  &--active {
    font-weight: var(--font-weight-bold);
  }

  &--red {
    color: var(--red);
  }

  &--clickable {
    cursor: pointer;

    &:hover:hover { // Higher specifity to override parent styles. @TODO: Fix this in a nicer way
      background-color: var(--grey-lighter);
    }
  }

  &--header {
    background-color: var(--black);
    color: var(--white);
    font-size: var(--font-size);
    font-weight: var(--font-weight-bold);

    &:is(.list-item--clickable):hover {
      background-color: var(--grey-darkest);
    }

    .list-item__icon {
      fill: currentcolor;
    }
  }
}
</style>
